import React, { useEffect } from "react";
import {
  AreaOfInterest,
  BubbleLayout,
  Home,
  PrevConfSection,
} from "../components";
import MediaPartner from "../components/sections/MediaPartner";

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Home />
      <BubbleLayout id={null} heading={"Conference Tracks"}>
        <AreaOfInterest />
      </BubbleLayout>
      <MediaPartner />
      <PrevConfSection />
    </div>
  );
};

export default HomePage;
